import apiService from '@/api/apiService';

export const getVersionSummary = async (id) => {
    const url = `/api/admin/balance/version/summary/${id}`;

    return apiService.GET(url);
};
